var map = {
	"./sofia-color": 51,
	"./sofia-color.png": 51,
	"./sofia-color_xl": 62,
	"./sofia-color_xl.png": 62,
	"./sofia-footer": 63,
	"./sofia-footer.png": 63,
	"./sofia-info-3d": 64,
	"./sofia-info-3d.png": 64,
	"./sofia-selection": 65,
	"./sofia-selection.png": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 610;